import { useEffect, useState } from 'react';

/**
 * hook to trigger the display of the first lead form
 **/
export const useShowFirstLeadForm = () => {
  const [trigger, setTrigger] = useState(0);

  const showFirstLeadForm = () => setTrigger(trigger + 1);

  useEffect(() => {
    if (trigger === 0) return;

    const clickFirstGetStartedButton = (firstContainer) => {
      const firstContainerButtons = containerButtons(firstContainer);
      const button = firstGetStartedButton(firstContainerButtons);

      button?.click();
    };

    const containerButtons = (container) => Array(...container.getElementsByTagName('button'));
    const firstContainer = () => document.querySelector('div[data-container-key="0"]');
    const firstGetStartedButton = (buttons) => buttons.find((b) => b.innerText === 'Get Started');

    const showForm = () => {
      const container = firstContainer();
      if (!container) return;

      clickFirstGetStartedButton(container);
    };

    showForm();
  }, [trigger]);

  return { showFirstLeadForm };
};

export default useShowFirstLeadForm;
